// The app-wide speech spool (C-7): IndexedDB `poneva-speech-spool` v1, with a
// memory fallback (`durable: false`) when IndexedDB is unavailable.
//
// Dictation: removed after the text is inserted or discarded; kept with Retry
// and Discard on failure. Meetings: a range is deleted after the server's
// durable acknowledgement. Every session is swept after 24 h and purged on
// sign-out or an account change.
import type { SpeechSpool } from '../contracts';
import { openIdbSpoolBackend } from './idb';
import { createSpeechSpool } from './spool';

export { createSpeechSpool } from './spool';
export { createMemorySpoolBackend, CHUNK_FRAMES } from './backend';
export type { SpoolBackend, StoredChunk, StoredFrame } from './backend';

/** Spool sessions older than this are swept on app start. */
export const SPOOL_TTL_MS = 24 * 60 * 60 * 1000;

export const speechSpool: SpeechSpool = createSpeechSpool({
  backend: () => openIdbSpoolBackend(),
  expectDurable: typeof globalThis.indexedDB !== 'undefined',
});
